import * as React from 'react';

import { ArticleHeading2, UIText1, UIText2 } from '@cian/ui-kit';
import classNames from 'classnames';

import * as styles from './Service.css';

export interface IServiceProps {
  title?: String;
  subTitle?: string;
  dataName: string;
  description: string[];
  bgColor: 'white' | 'gradient';
  checked: boolean;
  unavailable?: boolean;
  icon?: React.ReactNode;
  children: React.ReactNode;
  onClick(): void;
}

export const Service = ({
  onClick,
  bgColor,
  checked,
  title,
  subTitle,
  dataName,
  unavailable,
  icon,
  description,
  children,
}: IServiceProps) => (
  <div
    data-name={dataName}
    className={classNames(
      styles['card'],
      styles[bgColor],
      checked && styles['checked'],
      unavailable && styles['unavailable'],
    )}
    onClick={onClick}
  >
    <div className={styles['header']}>
      <div>
        <ArticleHeading2>{title}</ArticleHeading2>
        {subTitle && <UIText1>{subTitle}</UIText1>}
      </div>

      {icon}
    </div>

    <div className={classNames(styles['description'], !subTitle && styles['without_subtitle'])}>
      {description.map((item, index) => (
        <div key={index} className={styles['description_item']}>
          <UIText2>
            <div className={styles['info-row']}>
              <div className={styles['info-row-dot']} /> {item}
            </div>
          </UIText2>
        </div>
      ))}
    </div>

    <div className={styles['footer']}>{children}</div>
  </div>
);
